
import { useState } from 'react';
import './App.css';

function App() {

const [inputitem, setInputItem] = useState("");
const [addItem, setAddItem] = useState([]);
const [editIndex, setEditIndex] = useState(null);

const handleChange = (e) => {
  setInputItem(e.target.value) // Prevent empty inputs
}

const handleClick = () => {
  if (inputitem.trim() === "") return; // Prevent empty inputs
  if (editIndex !== null) {
      // Update existing item
      const newItems = [...addItem];
      newItems[editIndex] = inputitem;
      setAddItem(newItems);
      setEditIndex(null);
    } else {
      // Add new item
      setAddItem((prev) => [...prev, inputitem]);
    }

    // Clear input after adding or editing
    setInputItem("");
  };

  // Delete specific item
  const handleDelete = (index) => {
    const updatedItems = addItem.filter((_, i) => i !== index);
    setAddItem(updatedItems);
  };

  // Edit specific item
  const handleEdit = (index) => {
    setInputItem(addItem[index]); // Load that item back into the input box
    setEditIndex(index);          // Remember which one we’re editing
  };

  return (
    <div className="cover">
      <div className='container'>
        <div className='header'>
          <h1>SB Shopping List App</h1>
        </div>

        <div className='item-wrapper'>
          <input
          type='text'
          maxLength={20}
          value={inputitem}
          placeholder='Enter item'
          onChange={handleChange}/>
          <button className='add-btn' onClick={handleClick}>{editIndex !== null ? "Update Item" : "Add Item"}</button>
        </div>

        <div>
          <ol>
            {addItem.map((eachItem, index) => <li key={index}>
              {eachItem}
              <div className='button-wrapper'>
                <button className='edit-btn' onClick={() => handleEdit(index)}>Edit</button>
                <button className='delete-btn' onClick={() => handleDelete(index)}>Delete</button>
              </div>
              </li>)}
          </ol>
        </div>
      </div>
    </div>
  );
}

export default App;
